import { render, staticRenderFns } from "./BloqueoMaquinaInasistencia.vue?vue&type=template&id=58da6fb4&"
import script from "./BloqueoMaquinaInasistencia.vue?vue&type=script&lang=js&"
export * from "./BloqueoMaquinaInasistencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports